var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 13.3333L5.85 12.6368C5.75 12.544 5.66667 12.424 5.6 12.277C5.53333 12.13 5.5 11.9868 5.5 11.8475V11.6618L6.2 8.69039H1C0.716667 8.69039 0.479167 8.60141 0.2875 8.42343C0.0958337 8.24545 0 8.02492 0 7.76182V6.60111C0 6.50825 0.0083339 6.41926 0.0250006 6.33414C0.0416672 6.24903 0.0666671 6.16778 0.1 6.0904L2.35 1.16897C2.48333 0.905872 2.675 0.700812 2.925 0.553788C3.175 0.406764 3.45 0.333252 3.75 0.333252H10C10.55 0.333252 11.0208 0.515098 11.4125 0.878788C11.8042 1.24248 12 1.67968 12 2.19039V7.76182C12 7.94754 11.9625 8.12164 11.8875 8.28414C11.8125 8.44664 11.7 8.59754 11.55 8.73682L6.6 13.3333ZM4.05 2.19039L2 6.69397V6.83325H8.65L8.05 9.34039L10 7.57611V2.19039H4.05Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbsDown.0641287f38233bc4490c7e286ed145ef.svg";
export { ForwardRef as ReactComponent };